var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-12"},[_c('h1',[_vm._v("LOGGGED OUT")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }